<template>
  <div
    class="result-container"
    :style="`backgroundColor: ${activitySetting.bodyColor || '#2C1C47'}`"
  >
    <div class="result-box">
      <!-- 顶部中奖提示 -->
      <div
        class="top-result-container"
        :style="{
          background: `url(${activitySetting.resultTopBg2 ||
            '//x.autoimg.cn/cfw/cfw/activity/guessing-competition/result-top-bg2.png'}) no-repeat`,
          backgroundSize: '100% 100%',
        }"
      >
        <div
          class="top-result-wrapper"
          :style="{
            background: `url(${activitySetting.resultTopBg ||
              '//x.autoimg.cn/cfw/cfw/activity/guessing-competition/result-top-bg.png?t=11'}) no-repeat`,
            backgroundSize: '100% 100%',
          }"
        >
          <div
            class="tips-wrapper"
            :style="{
              color: `${activitySetting.resultTipColor || '#740700'}`,
            }"
            v-html="activityResultTipText"
          ></div>
        </div>
      </div>
      <!-- 本期奖品 -->
      <div class="prize-issue-wrapper result-prize-issue-wrapper">
        <div
          class="common-module-title"
          :style="{
            background: `url(${activitySetting.commontitlebg ||
              '//x.autoimg.cn/cfw/cfw/activity/guessing-competition/common-title-bg.png'}) no-repeat`,
            backgroundSize: '100% 100%',
            color: `${activitySetting.commonTitleColor || '#fff'}`,
          }"
        >
          本期奖品
        </div>
        <div
          class="common-container"
          :style="
            `backgroundImage: linear-gradient(270deg, ${activitySetting.commonContainerColorLeft ||
              '#FBE7B2'} 0%, ${activitySetting.commonContainerColorRight ||
              '#FBA66A'} 100%)`
          "
          @click.stop="viewAwardDetail(prizeList[0].useUrl)"
        >
          <div
            class="prize-wrapper"
            :style="
              `backgroundColor: ${activitySetting.commonWrapperColor || '#fff'}`
            "
          >
            <img
              :src="activityResult.prizeOpenImg || prizeList[0].prizeImg"
              alt="奖品的图片"
            />
          </div>
        </div>
      </div>
      <!-- 竞猜结果公布 -->
      <div
        class="result-announced-wrapper"
        v-if="Object.keys(activitySetting).length"
      >
        <div
          class="common-module-title"
          :style="{
            background: `url(${activitySetting.commontitlebg ||
              '//x.autoimg.cn/cfw/cfw/activity/guessing-competition/common-title-bg.png'}) no-repeat`,
            backgroundSize: '100% 100%',
            color: `${activitySetting.commonTitleColor || '#fff'}`,
          }"
        >
          竞猜结果公布
        </div>
        <div
          class="common-container"
          :style="
            `backgroundImage: linear-gradient(270deg, ${activitySetting.commonContainerColorLeft ||
              '#FBE7B2'} 0%, ${activitySetting.commonContainerColorRight ||
              '#FBA66A'} 100%)`
          "
        >
          <div
            class="result-wrapper"
            :style="
              `backgroundColor: ${activitySetting.commonWrapperColor || '#fff'}`
            "
          >
            <div class="top-info-wrapper">
              <div class="item-name" v-if="resultItemName">
                {{ resultItemName }}
              </div>
              <div class="item-price" v-if="resultItemPrice">
                <span>{{ resultItemPrice }}</span
                >元
              </div>
              <!-- <div class="mesure-entry-btn" @click.stop="goMeasureIndex">估损测算</div> -->
            </div>
            <div class="result-list-container" v-if="resultItemImgList.length">
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  v-for="(item, index) in resultItemImgList"
                  :key="index"
                >
                  <img :src="item" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 查看往期活动 -->
      <div class="view-past-wrapper">
        <div
          class="common-module-title"
          :style="{
            background: `url(${activitySetting.commontitlebg ||
              '//x.autoimg.cn/cfw/cfw/activity/guessing-competition/common-title-bg.png'}) no-repeat`,
            backgroundSize: '100% 100%',
            color: `${activitySetting.commonTitleColor || '#fff'}`,
          }"
        >
          查看往期活动
        </div>
        <div
          class="common-container"
          :style="
            `backgroundImage: linear-gradient(270deg, ${activitySetting.commonContainerColorLeft ||
              '#FBE7B2'} 0%, ${activitySetting.commonContainerColorRight ||
              '#FBA66A'} 100%)`
          "
        >
          <div
            class="past-list-wrapper"
            :style="
              `backgroundColor: ${activitySetting.commonWrapperColor || '#fff'}`
            "
          >
            <div class="tab-list">
              <div
                v-for="(item, index) in lastTabsList"
                :key="index"
                class="tab"
                :style="{
                  color: `${
                    selectTabIndex === index
                      ? activitySetting.pastTabActiveColor || '#FF6600'
                      : activitySetting.pastTabColor || '#111E36'
                  }`,
                  backgroundColor: `${
                    selectTabIndex === index
                      ? activitySetting.pastTabActiveBgColor ||
                        'rgba(255, 102, 0, 0.1)'
                      : activitySetting.pastTabBgColor || '#F8F9FC'
                  }`,
                }"
                @click.stop="tabChangeHandel(index)"
              >
                {{ item.name }}
              </div>
            </div>
            <div class="tab-switch-container">
              <div class="swiper-wrapper">
                <!-- 我的竞猜记录 -->
                <div class="swiper-slide" v-if="prizes.length">
                  <div
                    class="swiper-slider-wrapper"
                    v-for="(item, index) in prizes"
                    :key="index"
                  >
                    <div class="left">
                      <img :src="item.headImg" alt="" />
                    </div>
                    <div class="middle">
                      <p class="mid-top">{{ item.nickName }}</p>
                      <p class="mid-bottom">{{ item.joinTime }}</p>
                    </div>
                    <div class="right history">{{ item.joinNum }}</div>
                  </div>
                </div>
                <!-- 下期活动 -->
                <div class="swiper-slide" v-if="prediction.length">
                  <div
                    class="swiper-slider-wrapper"
                    v-for="(item, index) in prediction"
                    :key="index"
                    @click.stop="viewDetail(item.activityCode)"
                  >
                    <div class="left">
                      <img :src="item.activityImg" alt="" />
                    </div>
                    <div class="middle">
                      <p class="mid-top">{{ item.name }}</p>
                      <p class="mid-bottom">{{ item.startDateText }}</p>
                    </div>
                    <div
                      class="right"
                      :style="{
                        color: `${activitySetting.viewDetailColor || '#fff'}`,
                        backgroundColor: `${activitySetting.viewDetailBgColor ||
                          '#FFAA00'}`,
                      }"
                    >
                      查看详情
                    </div>
                  </div>
                </div>
                <!-- 往期活动 -->
                <div class="swiper-slide" v-if="previous.length">
                  <div
                    class="swiper-slider-wrapper"
                    v-for="(item, index) in previous"
                    :key="index"
                    @click.stop="viewDetail(item.activityCode)"
                  >
                    <div class="left">
                      <img :src="item.activityImg" alt="" />
                    </div>
                    <div class="middle">
                      <p class="mid-top">{{ item.name }}</p>
                      <p class="mid-bottom">{{ item.startDateText }}</p>
                      <p class="mid-tips">{{ winPrizeText(item) }}</p>
                    </div>
                    <div
                      class="right"
                      :style="{
                        color: `${activitySetting.viewDetailColor || '#fff'}`,
                        backgroundColor: `${activitySetting.viewDetailBgColor ||
                          '#FFAA00'}`,
                      }"
                    >
                      查看详情
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 底部客服 -->
      <div class="bottom-customer-service" v-if="activitySetting.showServer">
        <div class="left">
          <div class="left-top">
            <div class="portrait">
              <img src="../assets/images/portrait.jpg" alt="" />
            </div>
            <div class="tips">活动相关问题可咨询专属客服=></div>
          </div>
          <div class="left-bottom">
            <ul>
              <li>
                <span>添加客服还可获得：</span>
              </li>
              <li>
                <span class="symbol"></span
                ><span>专属优惠：赠送免费维修项目</span>
              </li>
              <li>
                <span class="symbol"></span
                ><span>专家协助：维修大咖在线答疑</span>
              </li>
              <li>
                <span class="symbol"></span
                ><span>养车技巧：教你怎么养车省钱</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="right" @click="customerCodeBigShow = !customerCodeBigShow">
          <img
            :src="
              activitySetting.customerCode ||
                '//x.autoimg.cn/cfw/cfw/activity/guessing-competition/customercode.png'
            "
            alt=""
          />
          <p class="tips">点击查看大图</p>
        </div>
      </div>
      <!-- 客服电话点击放大 -->
      <transition name="fade">
        <div
          class="customerCode-bigview-bg"
          v-show="customerCodeBigShow"
          @click="customerCodeBigShow = false"
        >
          <div class="customerCode-bigview-wrapper">
            <div class="close-icon" @click="customerCodeBigShow = false"></div>
            <div class="customerCode-img" @click.stop>
              <img
                :src="
                  activitySetting.customerCode ||
                    '//x.autoimg.cn/cfw/cfw/activity/guessing-competition/customercode.png'
                "
                alt=""
              />
            </div>
            <div class="tips">
              截图保存二维码<br />
              用微信扫一扫添加好友
            </div>
          </div>
        </div>
      </transition>
      <!-- 大图预览控件 -->
      <van-image-preview
        v-model="bigImageShow"
        :images="resultItemImgList"
        :start-position="startIndex"
        :loop="false"
        @change="onChange"
        @close="imagePreviewClose"
      >
        <template v-slot:index
          >{{ activeIndex + 1 }}/{{
            resultItemImgList && resultItemImgList.length
          }}</template
        >
      </van-image-preview>
    </div>
  </div>
</template>
<script>
import Api from "../api";
import * as Tool from "../tool";
import * as Common from "../tool/common";

import Swiper from "swiper/dist/js/swiper.js";
import "swiper/dist/css/swiper.min.css";
import { ImagePreview } from "vant";

export default {
  name: "Result",
  data() {
    return {
      activityResult: {}, // 中奖结果
      activityResultTipText: "", // 中奖结果文案
      activitySetting: {},
      activitySettingObj: {},
      prediction: [], // 活动预告
      previous: [], // 往期活动
      prizeList: [], // 本期奖品信息
      prizes: [], // 中奖记录
      selectTabIndex: 0,
      activityCode: Tool.getUrlParam().code || "",
      bannerSwiper: null,
      resultSwiper: null,
      lastTabsList: [],
      startIndex: 0, // 大图预览开始的索引
      activeIndex: 0, // 大图预览当前索引
      bigImageShow: false, // 竞猜结果大图预览
      resultItemName: "", // 竞猜结果公布
      resultItemPrice: "",
      resultItemImgList: [], // 大图预览list
      customerCodeBigShow: false, // 客服二维码大图预览
    };
  },
  components: {
    [ImagePreview.Component.name]: ImagePreview.Component,
  },
  created() {
    this.getActivityResult();
    this.getActivityRecord();
    let code = this.activityCode || Tool.getUrlParam().code || "";
    if (
      window.localStorage.getItem("activityCode") === code &&
      window.localStorage.getItem("prizeList") &&
      window.localStorage.getItem("activitySettingObj")
    ) {
      this.prizeList = JSON.parse(window.localStorage.getItem("prizeList"));
      this.activitySettingObj = JSON.parse(
        window.localStorage.getItem("activitySettingObj")
      );
      this.pvReport();
    } else {
      this.getActivitySetting((_) => {
        this.pvReport();
      });
    }
    Tool.setTitle("中奖结果");
  },
  computed: {
    winPrizeText() {
      return (val) => {
        let prizeText = JSON.parse(
          JSON.stringify(this.activitySettingObj[`${val.winPrizeText}`])
        );

        if (prizeText && prizeText.includes("*")) {
          prizeText = !!val.prizeLevel
            ? prizeText.replace("*", val.prizeLevel)
            : "本期活动您已中奖";
        }
        return val.winPrizeText ? prizeText : "";
      };
    },
  },
  methods: {
    // pv埋点
    pvReport() {
      let {
        home_site_id,
        home_category_id,
        home_sub_category_id,
      } = this.activitySettingObj;
      // pv 埋点
      Common.trackCustomPageInit(
        {
          site_id: home_site_id || 40,
          category_id: home_category_id || 1894,
          sub_category_id: home_sub_category_id || 22930,
          appKey: Tool.getCookie("app_key") || "",
          province: "",
          city: Tool.getCookie("app_cityid") || 110100,
          action: "cbz_yjjc_result_pv",
        },
        {
          pvareaid: Tool.getUrlParam().pvareaid || "",
          userId: Tool.getCookie("app_userid") || "",
          refpage_feed: Tool.getUrlParam().refpage || "",
        }
      );
    },
    // 跳转车损测算首页
    goMeasureIndex() {
      let isLocalEnv = window.location.origin.includes(
        "test.yczj.m.autohome.com.cn"
      );
      let linkUrl = `${
        isLocalEnv
          ? "http://cfwhd.yz.test.autohome.com.cn/accident-rights/autoDamage/measure-index"
          : "https://cfwhd.m.autohome.com.cn/accident-rights/autoDamage/measure-index"
      }`;
      Common.pageJumpHandel(linkUrl, {});
    },
    // 获取活动中奖结果
    getActivityResult() {
      let that = this;
      Api.getActivityResult({
        code: this.activityCode || Tool.getUrlParam().code || "",
      })
        .then((res) => {
          if (res.returncode === 0) {
            this.activityResult = res.result;
            this.activitySetting = res.result.setting || {};
            this.activityResultTipText = res.message;
            this.resultItemName =
              res.result &&
              res.result.setting &&
              res.result.setting.resultItemName;
            this.resultItemImgList =
              res.result &&
              res.result.setting &&
              res.result.setting.resultItemImgList &&
              (JSON.parse(res.result.setting.resultItemImgList) || []);
            this.resultItemPrice =
              res.result &&
              res.result.setting &&
              res.result.setting.resultItemPrice;
            // 中奖结果轮播初始化
            let loop = true;
            if (this.resultItemImgList && this.resultItemImgList.length === 1) {
              loop = false;
            }
            that.$nextTick(() => {
              that.resultSwiper = new Swiper(".result-list-container", {
                slidesPerView: "auto",
                loop,
                autoplay: {
                  disableOnInteraction: false,
                },
                observer: true,
                observeParents: true,
                on: {
                  click: function() {
                    that.viewBigImage(this.realIndex);
                    that.handleTrackCustomEvent(
                      "cbz_yjjc_result_tp",
                      "cbz_yjjc_result_tp_click"
                    );
                  },
                },
              });
            });
          }
        })
        .catch((error) => {
          this.$toast("当前无网络，请稍后重试");
          console.log(error, "获取活动结果接口异常----");
        });
    },
    // 获取往期活动
    getActivityRecord() {
      let that = this;
      Api.getActivityRecord({
        code: this.activityCode || Tool.getUrlParam().code || "",
      })
        .then((res) => {
          if (res.returncode === 0) {
            this.prediction = res.result.prediction;
            this.previous = res.result.previous;
            this.prizes = res.result.prizes;
            Object.keys(res.result).map((key, val) => {
              let name = "";
              if (key === "prediction") {
                name = "下期预告";
              } else if (key === "previous") {
                name = "往期活动";
              } else if (key === "prizes") {
                name = "竞猜记录";
              }
              let obj = {
                name,
                list: res.result[key],
              };
              if (res.result[key].length) {
                that.lastTabsList.unshift(obj);
              }
            });
            this.$nextTick(() => {
              // 初始化swiper
              that.bannerSwiper = new Swiper(".tab-switch-container", {
                slidesPerView: "auto",
                observer: true,
                observeParents: true,
                on: {
                  transitionEnd: function() {
                    that.selectTabIndex = this.realIndex;
                  },
                },
              });
            });
          }
        })
        .catch((err) => {
          this.$toast("当前无网络，请稍后重试");
          console.log(err, "获取往期活动接口异常");
        });
    },
    // 获取活动配置
    getActivitySetting(callback) {
      Api.getActivitySetting({
        code: this.activityCode || Tool.getUrlParam().code || "",
      })
        .then((res) => {
          if (res.returncode === 0) {
            this.prizeList = [...res.result.prizeList];
            this.activitySettingObj = { ...res.result.activitySetting };
            callback && callback();
          }
        })
        .catch((err) => {
          this.$toast("当前无网络，请稍后重试");
          console.log(err, "获取活动配置异常");
        });
    },
    onChange(index) {
      this.activeIndex = index;
    },
    viewBigImage(index) {
      this.activeIndex = index;
      this.startIndex = index;
      this.bigImageShow = true;
    },
    // 查看往期tabchange
    tabChangeHandel(index) {
      this.selectTabIndex = index;
      this.bannerSwiper && this.bannerSwiper.slideTo(index, 600, false);
      let page = "";
      let pageClick = "";
      if (index === 0) {
        page = "cbz_yjjc_result_xqhd";
        pageClick = "cbz_yjjc_result_xqhd_click";
      } else if (index === 1) {
        page = "cbz_yjjc_result_wqhd";
        pageClick = "cbz_yjjc_result_wqhd_click";
      } else if (index === 2) {
        page = "cbz_yjjc_result_zjjl";
        pageClick = "cbz_yjjc_result_zjjl_click";
      }
      this.handleTrackCustomEvent(page, pageClick);
    },
    // 查看活动详情
    viewDetail(activityCode) {
      let isLocalEnv = window.location.origin.includes(
        "http://t.yczj.m.autohome.com.cn"
      );
      let linkUrl = `${window.location.origin}${
        isLocalEnv ? "" : "/topic/guessing-competition"
      }/index?code=${activityCode || ""}`;
      Common.pageJumpHandel(linkUrl, {});
    },
    // 商品详情跳转地址
    viewAwardDetail(url) {
      this.handleTrackCustomEvent(
        "cbz_yjjc_result_bqjp",
        "cbz_yjjc_result_bqjp_click"
      );
      url && Common.pageJumpHandel(url, {});
    },
    imagePreviewClose() {
      this.handleTrackCustomEvent(
        "cbz_yjjc_result_ckdt",
        "cbz_yjjc_result_ckdt_click"
      );
    },
    // 点击统计
    handleTrackCustomEvent(page, action) {
      // eslint-disable-next-line
      trackCustomEvent(
        "yc_page_common_click",
        {
          bus: "1",
          page: page,
          refpage: Tool.getCookie("refpage") || "",
          channel: Tool.getCookie("channel") || "",
          city: Tool.getCookie("cityId") || 110100,
          action: action,
        },
        {
          userId: Tool.getCookie("app_userid") || "",
          refpage_feed: Tool.getCookie("refpageFeed") || "",
          pvareaid: Tool.getUrlParam().pvareaid || "",
        }
      );
    },
  },
};
</script>
<style lang="scss">
@import "../assets/style/pages/index.scss";
</style>
